export default __webpack_public_path__ + "static/media/Upload.e3dd7b00.svg";